/**
 * PATH: packages/email-hub/src/feature/email-layout/ConnectedMailboxesPopover.tsx
 * FILE_ID: EMAIL-LAYOUT-MAILBOX-POPOVER-001
 * PURPOSE: Render the shared mailbox switcher outside clipping ancestors.
 */

import { createPortal } from 'react-dom'
import { ConnectedMailboxesPanel } from '../components/ConnectedMailboxesPanel'
import type { EmailLayoutController } from './useEmailLayoutController'

export function ConnectedMailboxesPopover({
  layout,
}: {
  layout: EmailLayoutController
}) {
  if (!layout.mailboxesDockOpen || !layout.mailboxesCoords) return null

  return createPortal(
    <div
      id="email-mailboxes-dock-menu"
      role="dialog"
      aria-label="Connected mailboxes"
      className="fixed z-[1000] w-72 max-h-[60vh] overflow-y-auto bg-popover border border-border rounded-md shadow-xl p-2"
      style={{
        right: layout.mailboxesCoords.right,
        top: layout.mailboxesCoords.top,
        bottom: layout.mailboxesCoords.bottom,
      }}
    >
      <ConnectedMailboxesPanel
        emailAccounts={layout.emailAccounts}
        syncStatus={layout.syncStatus}
        activeEmail={
          layout.outlook.email
          ?? layout.gmail.email
          ?? layout.emailAccounts[0]?.email_address
          ?? null
        }
        isSyncing={layout.isSyncing}
        onSyncAccount={layout.handleSyncAccount}
        onReconnect={layout.handleReconnectMailbox}
        onOpenSettings={layout.openSettings}
        onAddMicrosoft={() => {
          void layout.connectOutlook()
        }}
        onAddGoogle={() => {
          void layout.gmail.authorize()
        }}
        currentUserId={layout.session?.user?.id ?? null}
        onSetPrivacy={layout.handleSetMailboxPrivacy}
      />
    </div>,
    document.body,
  )
}
